module.exports = __webpack_public_path__ + "static/img/onboarding-step2.17bb50c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/onboarding-step2.svg
// module id = 463
// module chunks = 0